<template>
  <form
    id="icon-animations"
    action=""
    class="icon-details-animations margin-bottom-2xl laptop:margin-top-2xl laptop:margin-bottom-0"
    style="--color-input-min-width: var(--icon-details-input-color-min-width)"
    @submit.prevent
  >
    <div class="styling-animate">
      <div
        class="size-xs padding-right-md padding-bottom-md"
        style="flex-shrink: 0"
      >
        <span
          class="text-uppercase padding-right-sm"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black)"
          >Animate</span
        ><site-link
          :to="$docs('/web/style/animate')"
          aria-label="With our web toolkit, you can easily add animations to an icon with a CSS class. Click to learn more"
          data-balloon-pos="right"
          data-balloon-length="xlarge"
          style="--link-color: var(--fa-gravy)"
        >
          <font-awesome-icon
            :icon="$v6.solid.faInfoCircle"
            fixed-width
          />
        </site-link>
      </div>

      <ul
        class="custom-radio-button-set display-flex align-stretch flex-wrap"
        style="--list-style-type: none; --padding-left: 0; --list-margin-top: 0; flex-grow: 1; gap: var(--spacing-xs)"
      >
        <li
          v-for="animationsSelect in iconAnimations"
          :key="animationsSelect.name"
          :style="radioCustomStyles"
          class="icon-details-animation-button position-relative"
        >
          <template v-if="animationsSelect.value === null">
            <input
              id="animations-none"
              type="radio"
              name="icon-animations"
              value=""
              style="appearance: none; position: absolute; box-shadow: none"
              @change="change('animation', animationsSelect.value)"
            />
            <label
              for="animations-none"
              class="margin-0 padding-y-xs padding-x-xl"
              style="border-radius: var(--border-radius-md); flex-grow: 1; background-color: var(--fa-lt-gravy)"
            >
              <font-awesome-icon
                :icon="$v6.solid.faBan"
                fixed-width
                class="padding-right-4xs"
              />
              <span>{{ animationsSelect.name }}</span>
            </label>
          </template>
          <template v-else>
            <input
              :id="`animations-${animationsSelect.value}`"
              type="radio"
              name="icon-animations"
              :value="animationsSelect.value"
              style="appearance: none; position: absolute; box-shadow: none"
              :checked="animationsSelect.value === styling.animation"
              @change="change('animation', animationsSelect.value)"
            />
            <label
              :for="`animations-${animationsSelect.value}`"
              class="margin-0 padding-y-xs padding-x-xl"
              style="border-radius: var(--border-radius-md); flex-grow: 1"
            >
              <font-awesome-icon
                :icon="$v6.solid[animationsSelect.icon]"
                fixed-width
                size="lg"
                class="padding-right-4xs"
              />
              <span>{{ animationsSelect.name }}</span>
            </label>
          </template>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
  import { animationOptions } from 'app/releases.js'

  export default {
    name: 'IconAnimations',

    props: {
      icon: {
        type: Object
      },
      styling: {
        type: Object,
        required: true
      },
      version: {
        type: Number
      }
    },

    computed: {
      iconAnimations() {
        return animationOptions(this.version)
      },

      radioCustomStyles() {
        return {
          'display': 'flex',
          'text-align': 'center',
          'align-items': 'center'
        }
      }
    },

    methods: {
      change(attr, value) {
        this.$posthog.capture('icon_preview_styling_update', {
          attribute: attr,
          value: value,
          icon_name: this.icon.name,
          icon_style: this.styling.style,
          icon_family: this.styling.family
        })

        return this.$emit('change', { ...this.styling, ...{ [attr]: value } })
      }
    }
  }
</script>
